import "./HolidaySchedule.html";
import "./HolidaySchedule.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import HolidayScheduleComponentController from "./HolidayScheduleComponentController";

export default class HolidayScheduleComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            groupTypeName: "@",
            holidayConfigurations: "=",
            holidaySchedule: "=",
            onCancel: "&",
            partnerId: "<",
        };
        this.controller = HolidayScheduleComponentController;
        this.templateUrl = "/App/Components/Forms/HolidaySchedule/HolidaySchedule.html";
    }
}

module("mmManagePortal").component("irHolidaySchedule", new HolidayScheduleComponent());
